import React from 'react';
import LandingPage from '@/components/LandingPage';

const Home = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-background via-background to-accent-light/10">
      <LandingPage />
    </div>
  );
};

export default Home;
